module.exports = __webpack_public_path__ + "img/sld_vcb_ta1_ba1_disable.71883a8f.svg";